<template>
  <el-row :gutter="15">
    <el-col :md="4">
      <Filters
        v-model="filters"
        :resource="$sdk.invoiceimport"
        :primary-fields="['carrier', 'date', 'status']"
        @apply="loadImports()"
      />
    </el-col>
    <el-col :md="20">
      <el-card v-loading="isLoadingImports">
        <ImportTable :imports="imports" />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="page"
            :page-sizes="[5, 10, 20, 30]"
            :page-size.sync="perPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="loadImports()"
            @current-change="loadImports()"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import InvoiceImportDialog from '@/components/Application/Billing/Invoices/InvoiceImportDialog'
import InvoiceUploadDialog from '@/components/Application/Billing/CarrierInvoices/UploadDialog'
import Vue from 'vue'
import ImportTable from '@/components/Application/Billing/CarrierInvoices/Table'
import Filters from '@/components/Filters/Simplified'

export default {
  components: {
    ImportTable,
    Filters
  },
  data () {
    return {
      title: 'Carrier Invoices',
      breadcrumb: {
        name: 'Carrier Invoices',
        route: { name: 'billing-carrier' }
      },
      imports: [],
      filters: [],
      isLoadingImports: false,
      invoiceImportDialogVisible: false,
      invoiceImportDialogInstance: undefined,
      invoiceUploadDialogInstance: undefined,
      infoDialogInstance: undefined,
      page: 1,
      perPage: 20,
      total: 0,
      autoRefresh: false,
      refreshTitle: 'Auto Refresh (Off)',
      refreshTimer: undefined
    }
  },
  computed: {
    actions () {
      return [
        [
          {
            name: this.refreshTitle,
            icon: ['fal', 'sync'],
            event: this.setAutoRefresh
          },
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: this.loadImports
          }
        ],
        [
          {
            name: 'Import',
            icon: ['fal', 'plus'],
            event: this.createImport
          },
          {
            name: 'Upload',
            icon: ['fal', 'upload'],
            event: this.uploadImport
          }
        ]
      ]
    }
  },
  watch: {
    invoiceImportDialogVisible (visible) {
      if (!visible && typeof this.invoiceImportDialogInstance !== 'undefined') {
        this.invoiceImportDialogInstance.$destroy()
        this.invoiceImportDialogInstance.$el.remove()
        this.invoiceImportDialogInstance = undefined
      }
    },
    invoiceUploadDialogVisible (visible) {
      if (!visible && typeof this.invoiceUploadDialogInstance !== 'undefined') {
        this.invoiceUploadDialogInstance.$destroy()
        this.invoiceUploadDialogInstance.$el.remove()
        this.invoiceUploadDialogInstance = undefined
      }
    }
  },
  created () {
    this.loadImports()
  },
  methods: {
    setAutoRefresh () {
      if (this.autoRefresh === true) {
        this.autoRefresh = false
        this.refreshTitle = 'Auto Refresh (Off)'
        clearInterval(this.refreshTimer)
        this.refreshTimer = undefined
      } else {
        this.autoRefresh = true
        this.refreshTitle = 'Auto Refresh (30s)'
        this.refreshTimer = setInterval(this.loadImports, 30000)
      }
    },
    loadImports () {
      this.isLoadingImports = true
      this.$sdk.invoiceimport.list(builder => {
        builder.limit = 20
        builder.include = ['carrier']
        builder.order = 'import_index_id:desc'
        builder.filters = this.filters
        builder.page = this.page
        builder.limit = this.perPage
      }).then(res => {
        this.imports = res
        this.total = res.total
        this.isLoadingImports = false
      })
    },
    createImport () {
      const InvoiceImportDialogClass = Vue.extend(InvoiceImportDialog)

      this.invoiceImportDialogInstance = new InvoiceImportDialogClass()

      this
        .invoiceImportDialogInstance
        .$on('destroy', () => {
          this.invoiceImportDialogVisible = false
        })

      this
        .invoiceImportDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.invoiceImportDialogInstance.$el)

      this.invoiceImportDialogVisible = true
    },
    uploadImport () {
      const InvoiceUploadDialogClass = Vue.extend(InvoiceUploadDialog)

      this.invoiceUploadDialogInstance = new InvoiceUploadDialogClass()

      this
        .invoiceUploadDialogInstance
        .$on('destroy', () => {
          this.invoiceUploadDialogVisible = false
          this.loadImports()
        })

      this
        .invoiceUploadDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.invoiceUploadDialogInstance.$el)

      this.invoiceUploadDialogVisible = true
    }
  }
}
</script>
